import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { increDecreHistoryProcessClassConfig } from './IncreDecreHistoryProcessClass.name';

/** 増減履歴処理区分のENUM */
enum IncreDecreHistoryProcessClass {
  faAcquisition = '1',
  faRetire = '2',
  faEstimateChange = '3',
  faImpairmentLossEntry = '4',
  faInfoChange = '5',
  faReductionEntry = '6',
  faDepAdjEntry = '8',
  faUnusedPeriodSetting = '9',
  faDivision = '10',
  faSales = '11',
  faTransfer = '12',
  faAllocBasisSetting = '13',
  faAddDepSetting = '14',
  faSegmentChange = '15',
  faSubCategoryChange = '16',
  faDeclarationItemChange = '17',
  faImpairmentReversal = '18',
  laEntry = '19',
  leaseLiabilityEstimateChange = '21',
}

const increDecreHistoryProcessClassMap = new Map([
  ['1', IncreDecreHistoryProcessClass.faAcquisition],
  ['2', IncreDecreHistoryProcessClass.faRetire],
  ['3', IncreDecreHistoryProcessClass.faEstimateChange],
  ['4', IncreDecreHistoryProcessClass.faImpairmentLossEntry],
  ['5', IncreDecreHistoryProcessClass.faInfoChange],
  ['6', IncreDecreHistoryProcessClass.faReductionEntry],
  ['8', IncreDecreHistoryProcessClass.faDepAdjEntry],
  ['9', IncreDecreHistoryProcessClass.faUnusedPeriodSetting],
  ['10', IncreDecreHistoryProcessClass.faDivision],
  ['11', IncreDecreHistoryProcessClass.faSales],
  ['12', IncreDecreHistoryProcessClass.faTransfer],
  ['13', IncreDecreHistoryProcessClass.faAllocBasisSetting],
  ['14', IncreDecreHistoryProcessClass.faAddDepSetting],
  ['15', IncreDecreHistoryProcessClass.faSegmentChange],
  ['16', IncreDecreHistoryProcessClass.faSubCategoryChange],
  ['17', IncreDecreHistoryProcessClass.faDeclarationItemChange],
  ['18', IncreDecreHistoryProcessClass.faImpairmentReversal],
  ['19', IncreDecreHistoryProcessClass.laEntry],
  ['21', IncreDecreHistoryProcessClass.leaseLiabilityEstimateChange],
]);

const rawValueToIncreDecreHistoryProcessClass = rawValueToEnumWithDefault(
  increDecreHistoryProcessClassMap,
  IncreDecreHistoryProcessClass.faAcquisition,
);

const increDecreHistoryProcessClassToDisplay = enumToNameWithDefault(
  IncreDecreHistoryProcessClass,
  increDecreHistoryProcessClassConfig,
);

export {
  IncreDecreHistoryProcessClass,
  increDecreHistoryProcessClassToDisplay,
  rawValueToIncreDecreHistoryProcessClass,
};
